export enum LoginType {
  SEPI = 'SEPI',
  CAS = 'CAS',
}
